import { ActivityApplicationEnum } from '~/types/interfaces/activity';

/**
 * Transforms the status of an activity application to a normalized format.
 *
 * @param status - The status of the activity application.
 * @returns The normalized status.
 */
export const normalizeActivityApplicationStatus = (
  status: ActivityApplicationEnum,
) => {
  if (status === ActivityApplicationEnum.Rejected) {
    return 'Declined';
  }

  return status;
};
